import { RouteAuthenticationRequirement, RouteItem } from '@cks-internal/react-base';
import { NarrowLayout } from '../components/layout/narrowLayout';
import { AppRoles } from '../constants/appRoles';
import { ApplicationRoutes } from '../constants/appRoutes';

export const CrmNavItems: RouteItem = {
  text: 'CRM',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [AppRoles.UserAdmin, AppRoles.Admin],
  layout: <NarrowLayout />,
  subItems: [
    {
      text: 'Manage Companies',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.crm.manageCompanies,
      allowedRoles: [AppRoles.ProductAdmin, AppRoles.Admin],
      async lazy() {
        const component = await import('../features/crm/companies/manageCompanies');
        return { Component: component.ManageCompanies };
      }
    }
  ]
};
